
<template>
  <div class="swiper swiper--home">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item,index) in data">{{ item.node.thumbnail_src }}</div>
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
module.exports = {
  data: function() {
    return {
      data: []
    }
  },
  computed: {
    fullname: function () {
      return this.firstname + ' ' + this.lastname
    }
  },
  mounted() {
    axios.get('https://www.instagram.com/explore/tags/leparisbretagne/?__a=1', function (req, res) {
      res.header("Access-Control-Allow-Origin", "*");
      res.send('Hello World');
    });

  }
}
</script>